import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  modal_message:null,
  open_modal:false,
  decision:null
 
};

const Confirm_Modal_Slice = createSlice({
  name: "Confirm_Modal",
  initialState,
  reducers: {
     open_confirm_modal(state,action){
         state.decision=null;
         state.open_modal = true;
         state.modal_message = action.payload
     },
     close_confirm_modal(state,action){
        state.open_modal = false;
        state.modal_message = ""
     },
     change_confirm_decision(state,action){
        state.decision = action.payload
     }

  },
});

export const {
    open_confirm_modal,
    close_confirm_modal,
    change_confirm_decision
} = Confirm_Modal_Slice.actions

export default Confirm_Modal_Slice.reducer;